import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0F0F0F] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-6">
            <img
              src="/abkasan-logo.png"
              alt="Abkasan Luxe Home Developers"
              className="h-16 w-auto"
            />
            <p className="text-[#A3A3A3] text-sm leading-relaxed">
              Crafting exceptional living spaces that define luxury in Uganda. 
              Your trusted partner in premium real estate development.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-display text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {['About', 'Services', 'Projects', 'Investment', 'Consultation', 'Blog', 'Contact'].map((link) => (
                <li key={link}>
                  <Link 
                    to={`/${link.toLowerCase()}`} 
                    className="text-[#A3A3A3] hover:text-[#C6A87C] text-sm transition-colors"
                  >
                    {link}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-display text-lg mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Phone size={18} className="text-[#C6A87C] mt-0.5 flex-shrink-0" />
                <div className="text-sm">
                  <p className="text-[#A3A3A3]">MTN: +256 773 273 961</p>
                  <p className="text-[#A3A3A3]">Airtel: +256 759 894 639</p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Mail size={18} className="text-[#C6A87C] mt-0.5 flex-shrink-0" />
                <span className="text-[#A3A3A3] text-sm">info@abkasanluxehomes.com</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-[#C6A87C] mt-0.5 flex-shrink-0" />
                <span className="text-[#A3A3A3] text-sm">Kampala, Uganda</span>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-display text-lg mb-6">Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy" className="text-[#A3A3A3] hover:text-[#C6A87C] text-sm transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-[#A3A3A3] hover:text-[#C6A87C] text-sm transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <span className="text-[#A3A3A3] text-sm">
                  Licensed Real Estate Developer
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          <p className="text-[#525252] text-sm">
            (c) {currentYear} Abkasan Luxe Home Developers. All rights reserved.
          </p>
          <p className="text-[#525252] text-xs">
            Building Dreams, Delivering Excellence
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
